module.exports = __webpack_public_path__ + "img/ipfs.41f8c569.svg";